/**
* 随管家
*/

import '@common/polyfill/src/promise'
import useragent from '@common/useragent'
import clientBridge from '@common/client/src/bridge'

import { callbackHandler } from '../utils'

import BaseAuth from './base'

class SuiguanjiaAuth extends BaseAuth {
  constructor(options) {
    super(options)
    if (useragent.isSuiguanjia) {
      // 随管家
      this.isClientHit = true
    }
    this.isRelyOnIsLoginCookie = false
  }
  // 请求随管家协议
  callClientBridge() {
    console.log(this.loginType) // 这句代码是为了避开eslint语法检查
    let params = {}
    if (this.loginType.force || this.loginType.tokenError) {
      params = {
        type: 3,
      }
    } else if (this.loginType.silent) {
      params = {
        type: 1,
      }
    } else if (this.loginType.tokenExpire) {
      params = {
        type: 4
      }
    } else {
      params = {
        type: 2,
      }
    }
    const fnRequestLogin = (resolve, reject, uri) => {
      clientBridge.call(clientBridge.uriSuiguanjia(uri, params, 'onLoginResult'), 'onLoginResult', (dataLogin) => {
        if (dataLogin.data) {
          // 用户已登录或登录成功
          BaseAuth.setOAuth2Token(dataLogin.data.token)
          resolve()
        } else {
          reject(dataLogin)
        }
      })
    }
    return new Promise((resolve, reject) => {
      fnRequestLogin(resolve, reject, 'sgj://app/goLogin')
    })
  }
  // 处理客户端返回的数据
  async clientDataHandler() {
    try {
      await this.callClientBridge()
      this.requestLoginApiSuccessCallback()
    } catch (error) {
      console.error('Suiguanjia Login Error:', error)
      if (error.code === '999991') {
        // 用户取消登录
        callbackHandler(this.options.cancel)
      } else {
        callbackHandler(this.options.error, { msg: '登录失败，请重试' })
      }
    }
  }
  // 获取token
  getToken() {
    if (!this.isClientHit) return undefined
    return Promise.resolve({})
  }
  // 登录
  login() {
    if (!this.isClientHit) return
    if (this.checkIsLogin()) {
      this.requestLoginApiSuccessCallback()
    } else {
      this.clientDataHandler()
    }
  }
}

export default SuiguanjiaAuth



// WEBPACK FOOTER //
// ./node_modules/@finance/login/src/client/suiguanjia.js